import * as tslib_1 from "tslib";
import api from 'src/api';
var ENDPOINT = 'api/task/survey/';
var SurveyApi = /** @class */ (function () {
    function SurveyApi() {
    }
    SurveyApi.get = function (competencyId) {
        return tslib_1.__awaiter(this, void 0, Promise, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.get(ENDPOINT + competencyId)];
                    case 1:
                        response = _a.sent();
                        if (response.status !== 200) {
                            return [2 /*return*/, ''];
                        }
                        return [2 /*return*/, response.data.link || ''];
                }
            });
        });
    };
    return SurveyApi;
}());
export default SurveyApi;



//////////////////
// WEBPACK FOOTER
// ./src/services/SurveyApi.ts
// module id = 745
// module chunks = 0